import { z } from 'zod';
export const SucursalSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string(),
    descripcion: z.string().nullable().optional(),
    activa: z.boolean().optional(),
});
export const PuntoVentaSchema = z.object({
    id: z.string().uuid(),
    sucursalId: z.string().uuid().optional(),
    nombre: z.string(),
    descripcion: z.string().nullable().optional(),
    activo: z.boolean().optional(),
});
export const PuntoEncuentroSchema = z.object({
    id: z.string().uuid(),
    sucursalId: z.string().uuid().optional(),
    nombre: z.string(),
    descripcion: z.string().nullable().optional(),
    activo: z.boolean().optional(),
});
export const TarifaSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string(),
    tipoClase: z.string(),
    disciplina: z.string().nullable().optional(),
    duracionHoras: z.union([z.string(), z.number()]).optional(),
    cantPersonasMin: z.number().optional(),
    cantPersonasMax: z.number().optional(),
    precio: z.union([z.string(), z.number()]).optional(),
    modoPrecio: z.string().optional(),
    visibleWeb: z.boolean().optional(),
    vigenteDesde: z.string().nullable().optional(),
    vigenteHasta: z.string().nullable().optional(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .nullable()
        .optional(),
    activa: z.boolean().optional(),
});
export const EmpleadoSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string(),
    apellido: z.string(),
    email: z.string().nullable().optional(),
    telefono: z.string().nullable().optional(),
    activo: z.boolean().optional(),
    // Para deduplicar cuando una persona es empleado + promotor a la vez.
    uusuarioId: z.string().uuid().nullable().optional(),
});
export const PromotorSchema = z.object({
    id: z.string().uuid(),
    tipo: z.string().optional(),
    nombre: z.string(),
    apellido: z.string().nullable().optional(),
    descripcion: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    telefono: z.string().nullable().optional(),
    activo: z.boolean().optional(),
    esEmpleado: z.boolean().optional(),
    // FK al empleado si es promotor interno (vinculo persona).
    empleadoId: z.string().uuid().nullable().optional(),
});
